const en = {
    scanAddSuccess: 'Scan order added successfully',
    scanAddFail: 'Failed to add scan order',
    tip: 'Tip',
    delScanTip1: 'Are you sure you want to delete this scan order? Data cannot be recovered after deletion.',
    scanDelSuccess: 'Scan order deleted successfully',
    addScan: 'Add new scan order',
    scanCount: 'Total scanned {{count}} items',
    oprtName: 'Operator: {{name}}',
    enterCode: 'Please enter the barcode',
    cancel: 'Cancel',
    confirm: 'OK',
    sameCheck: 'Duplicate check',
    conIn: 'Confirm inbound',
    conOut: 'Confirm outbound',
    addScanTip:"By default, data is split using 'Space' or 'Enter'. Duplicate barcodes are removed after input.",
    scanSheet1: 'Scan Sheet 1',
    sameBarcodeTip1: 'There are barcode duplicates in the same product. Please modify the data and submit again.',
    sameBarcodeTip2: 'There are duplicate barcodes in the scanning form. Please check the data and resubmit.',
    confirmClearData: 'The current page already has content, are you sure to clear the data?',
    scanSheetNum: 'Scan sheet {{num}}',
    scanSheetCount: 'Scan order {{count}}',  
    fillBarcodeFirst: 'Please fill in the barcode first before adding data.',
    selProductForBarcode: 'Product: ',
    selProductForBarcodePl: 'Please select a product for the barcode',
    clear: 'Clear',
    addNew: 'Add',
    scanSheetData: 'Scan sheet data',
    addScanMax: 'At most, {{num}} scan orders can be added',
    scanNumExceedMax: 'The number of barcodes exceeds the maximum limit',
    scanNumExceedMaxTip: 'You can only input a maximum of {{num}} barcodes',
    residueBarcodeNum: 'There are still {{residueNum}} barcodes that can be added. Please modify the data and resubmit',
    confirmDelBarcodesNum: 'Are you sure to delete the selected {{delNum}} barcodes?',
    delText: 'Delete',
    saveText: 'Save',
    saveAndAdd: 'Save and add',
    addBarcodes: 'Add barcode',
    delBarcodes: 'Delete',
    notFoundBarcodes: 'Barcode not found',
    confirmClearDataTip: 'The current page already has content that has not been saved. Are you sure you want to delete it?',
    searchBarcodePlaceholder: 'Please enter barcode search',
    notSelectedBarcode: 'Currently not selected to delete barcode',
    noDelScanSheet: 'When there is only one data left, it is the default data and cannot be deleted.',
    butDelTooltip: 'Clear the current product and barcode data',
    butSaveTooltip: 'Save the current scan data',
    butSaveAndAddTooltip: 'Save scan sheet data and add a new scan sheet',
    manufactureBarcode: 'Generate barcodes',
    barcodeNotEmpty: 'Barcode data cannot be empty',
    saveScanTip: 'Please save the current scan first',
    barcodePrefix: 'Prefix',
    barcodeSuffix: 'Suffix',
    barcodeStartNum: 'Start num',
    barcodeEndNum: 'End num',
    barcodeMaxCount: 'Maximum number limit for suffix generation ({maxCount}})',
    generateBarcode: 'Generate barcodes',
    scanDataFillTip: 'Please fill in the existing scan data',
    allCheckBarcodes: 'All',
    endLessThanStart: 'The ending number cannot be less than the starting number',
    selectProductTip: 'Please select a product',
    barcodeTip: 'Please fill in the barcode',
    productAndBarcodeTip: 'Please select the product and fill in the barcode',
    delInInventory: 'Delete and confirm storage',
    delOutInventory: 'Delete and confirm the outbound shipment',
    selectPl: 'Please select',
};

export default en;